import React, { useEffect } from "react";
import { useCrewStore } from "../../store/crewStore";
import HomeView from "./HomeView";
import CrewDetail from "./CrewDetail";
import AdminTopBar from "./AdminTopBar";
import NotificationBell from "./NotificationBell";
import { workDateToISO } from "../../utils";

const AdminDashboard: React.FC = () => {
  const { crews, currentCrewId, setCurrentCrewId, removeCrew } = useCrewStore();

  const view = currentCrewId ? "crew-detail" : "home";

  return (
    <div id="app">
      <div id="view-home" className={`view ${view === "home" ? "active" : ""}`}>
        <HomeView />
      </div>
      <div
        id="view-crew"
        className={`view ${view === "crew-detail" ? "active" : ""}`}
      >
        {currentCrewId && (
          <CrewDetail
            crewId={currentCrewId}
            onBack={() => setCurrentCrewId(null)}
          />
        )}
      </div>
      <AdminTopBar />
      <NotificationBell />
      <div id="modal-overlay" className="modal-overlay" />
      <div id="modal-add-crew" className="modal" style={{ display: "none" }} />
      <div
        id="modal-add-delivery"
        className="modal"
        style={{ display: "none" }}
      />
      <div
        id="modal-delete-confirm"
        className="modal"
        style={{ display: "none" }}
      />
    </div>
  );
};

export default AdminDashboard;
